<template>
  <div class="container-md col-lg-10 col-md-10 pt-2 organisation-list">
    <LoadingOverlay v-if="isCustomerFetch" />
    <div class="pb-5 mb-2" v-else>
      <h3 class="text-primary m-1 pt-1 pb-2">Marketplace Relationships</h3>
      <div>
        <CTabs variant="tabs" :active-tab.sync="activeTab">
          <CTab
            :title="'Related Customers' + ` (${organisationRelations.length})`"
          >
            <CDataTable
              v-if="activeTab === 0"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="organisationsRelated"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
              @update:table-filter-value="onSearch"
            >
              <template #action="{ item, index }">
                <td class="py-2">
                  <div class="d-flex">
                    <CButton
                      v-show="collapseIndex === index"
                      color="primary"
                      square
                      variant="outline"
                      size="sm"
                      class="mr-1"
                      @click="toggleDetails(item, index)"
                      v-c-tooltip="{
                        content: 'Collapse all child Organizations!',
                        placement: 'left',
                        appendToBody: true,
                      }"
                    >
                      <em class="fa fa-minus"></em>
                    </CButton>
                    <CButton
                      v-show="collapseIndex !== index"
                      color="primary"
                      square
                      variant="outline"
                      size="sm"
                      class="mr-1"
                      @click="toggleDetails(item, index)"
                      v-c-tooltip="{
                        content: 'List all child Organizations!',
                        placement: 'left',
                        appendToBody: true,
                      }"
                    >
                      <em class="fa fa-plus"></em>
                    </CButton>
                    <CButton
                      color="danger"
                      square
                      size="sm"
                      class="mr-1"
                      @click="changeStatus(item, false)"
                      v-c-tooltip="'Deactivate'"
                      >Deactivate</CButton
                    >
                  </div>
                </td>
              </template>

              <template #details="{ item, index }">
                <CCollapse
                  :show="collapseIndex === index"
                  :duration="collapseDuration"
                >
                  <div class="p-3">
                    <h6 class="text-primary">
                      {{ item.customer_name }} - Child Organizations ({{
                        item.rawData.customer_organisations.length || "0"
                      }}
                      Record{{
                        item.rawData.customer_organisations.length > 1
                          ? "s"
                          : ""
                      }})
                    </h6>
                    <CDataTable
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :items="item.children"
                      :fields="childFields"
                      :items-per-page="small ? limit : 5"
                    >
                    </CDataTable>
                  </div>
                </CCollapse>
              </template>
            </CDataTable>
          </CTab>

          <CTab
            :title="
              'Unrelated Customers' + ` (${organisationUnRelated.length})`
            "
          >
            <CDataTable
              v-if="activeTab === 1"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="organisationUnRelated"
              :fields="fields"
              :items-per-page="small ? limit : 5"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
            >
              <template #action="{ item, index }">
                <td class="py-2">
                  <div class="d-flex">
                    <CButton
                      v-show="collapseIndex1 === index"
                      color="primary"
                      square
                      variant="outline"
                      size="sm"
                      class="mr-1"
                      @click="toggleDetails1(item, index)"
                      v-c-tooltip="{
                        content: 'Collapse all child Organizations!',
                        placement: 'left',
                        appendToBody: true,
                      }"
                    >
                      <em class="fa fa-minus"></em>
                    </CButton>
                    <CButton
                      v-show="collapseIndex1 !== index"
                      color="primary"
                      square
                      variant="outline"
                      size="sm"
                      class="mr-1"
                      @click="toggleDetails1(item, index)"
                      v-c-tooltip="{
                        content: 'List all child Organizations!',
                        placement: 'left',
                        appendToBody: true,
                      }"
                    >
                      <em class="fa fa-plus"></em>
                    </CButton>
                    <CButton
                      color="primary"
                      square
                      size="sm"
                      class="mr-1"
                      @click="changeStatus(item, true)"
                      v-c-tooltip="'Activate'"
                      >Activate</CButton
                    >
                  </div>
                </td>
              </template>
              <template #details="{ item, index }">
                <CCollapse
                  :show="collapseIndex1 === index"
                  :duration="collapseDuration"
                >
                  <div class="p-3">
                    <h6 class="text-primary">
                      {{ item.customer_name }} - Child Organizations ({{
                        item.rawData.customer_organisations.length || "0"
                      }}
                      Record{{
                        item.rawData.customer_organisations.length > 1
                          ? "s"
                          : ""
                      }})
                    </h6>
                    <CDataTable
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :items="item.children"
                      :fields="childFields"
                      :items-per-page="small ? limit : 5"
                    >
                    </CDataTable>
                  </div>
                </CCollapse>
              </template>
            </CDataTable>
          </CTab>

          <CTab :title="'Partners' + ` (${partnerTotal})`">
            <CDataTable
              v-if="activeTab === 2"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :items="partners"
              :fields="partnerFields"
              :items-per-page="limit"
              sorter
              :tableFilter="{ label: 'Search', placeholder: 'Type for search' }"
              pagination
              class="p-2 border"
              @update:table-filter-value="onPartnerSearch"
            >
            </CDataTable>
            <CRow class="mt-3">
              <CCol md="12" class="d-flex justify-content-end">
                <Pagination
                  :total="partnerQueryCount"
                  :perPage="partnerPerPage"
                  @pagechanged="partnerPagechanged"
                  position="center"
                  :showTotalRecords="true"
                  :defaultPage="partnerPage"
                />
              </CCol>
            </CRow>
          </CTab>
        </CTabs>
      </div>
    </div>
    <Modal
      :modalTitle="confirmationModal.modalTitle"
      :modalColor="confirmationModal.modalColor"
      :modalContent="confirmationModal.modalContent"
      :isShowPopup="confirmationModal.isShowPopup"
      :buttons="confirmationModal.buttons"
      :modalCallBack="confirmationModalCallBack"
      :closeOnBackdrop="false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OrganisationEdit from "@/containers/Organisation/EditOrganisation";
import Modal from "@/components/reusable/Modal";
import Pagination from "@/components/reusable/Pagination";

export default {
  components: {
    OrganisationEdit,
    Modal,
    Pagination,
  },
  data() {
    return {
      activeTab: 0,
      collapseDuration: 0,
      collapseIndex: null,
      collapseIndex1: null,
      limit: 10,
      small: true,
      striped: true,
      bordered: true,
      fields: [
        { key: "customer_name", label: "Customer Name", _style: "width:25%" },
        { key: "path_acronym", label: "Path Acronym", _style: "width:10%" },
        { key: "location", label: "Location", _style: "width:10%" },
        {
          key: "main_contact_name",
          label: "Main Contact Name",
          _style: "width:15%;white-space:nowrap",
        },
        { key: "email", label: "Email", _style: "width:15%" },
        {
          key: "action",
          label: "Action",
          _style: "width:10%",
        },
      ],
      childFields: [
        {
          key: "organisation_name",
          label: "Organisation Name",
          _style: "width:25%",
        },
        { key: "path_acronym", label: "Path Acronym", _style: "width:10%" },
        { key: "location", label: "Location", _style: "width:10%" },
        {
          key: "main_contact_name",
          label: "Main Contact Name",
          _style: "width:15%",
        },
        { key: "email", label: "Email", _style: "width:15%" },
      ],
      partnerPage: 1,
      partnerSearchValue: null,
      partnerPerPage: 10,
      partnerTotal: 0,
      partnerQueryCount: 0,
      partnerSearchTimeout: null,
      partnerFields: [
        { key: "name", label: "Institution Name", _style: "width:25%" },
        { key: "organisation_type", label: "Customer Type", _style: "width:15%" },
        { key: "main_contact", label: "Main Contact", _style: "width:20%" },
        { key: "tags", _style: "width:15%" },
        { key: "country", _style: "width:15%" },
      ],
      confirmationModal: {
        modalTitle: "",
        modalColor: "primary",
        modalContent: "",
        isShowPopup: false,
        buttons: [ "No","Yes"],
        data: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "organisationRelations",
      "unrelatedOrganisationRelations",
      "isCustomerFetch",
      "getUser",
      "getPartnerList"
    ]),
    partners() {
      return (
        (this.getPartnerList &&
          this.getPartnerList.length &&
          this.getPartnerList.map((val) => ({
            name: val.name,
            organisation_type: val.organisation?.organisation_type_name,
            main_contact: val.organisation?.main_contact,
            tags: val?.tags?.join(", ") || "",
            country: val?.country_name || "",
            rawData: val,
          }))) ||
        []
      );
    },
    organisationsRelated() {
      return (
        (this.organisationRelations &&
          this.organisationRelations.length &&
          this.organisationRelations
            .map((item) => ({
              customer_name: item?.customer_name,
              path_acronym: item?.rel_path_acronym || "-",
              location: `${item?.city || ""}${
                item?.city && item?.country_name ? ", " : ""
              }${item?.country_name || ""}`,
              main_contact_name: item?.contact_name || "-",
              email: item?.contact_email || "-",
              rawData: item,
              children: item?.customer_organisations.map((org) => ({
                organisation_name: org?.organisation_name,
                path_acronym: org?.path_acronym,
                location: `${org?.city || ""}${
                  org?.city && org?.country_name ? ", " : ""
                }${org?.country_name || ""}`,
                main_contact_name: org?.contact_name,
                email: org?.contact_email,
              })),
            }))
            .sort((a, b) => a.customer_name?.localeCompare(b.customer_name))) ||
        []
      );
    },
    organisationUnRelated() {
      return (
        (this.unrelatedOrganisationRelations &&
          this.unrelatedOrganisationRelations.length &&
          this.unrelatedOrganisationRelations
            .map((item) => ({
              customer_name: item?.customer_name,
              path_acronym: item?.path_acronym,
              location: `${item?.city || ""}${
                item?.city && item?.country_name ? ", " : ""
              }${item?.country_name || ""}`,
              main_contact_name: item?.contact_name,
              email: item?.contact_email,
              rawData: item,
              children: item?.customer_organisations.map((org) => ({
                organisation_name: org?.organisation_name,
                path_acronym: org?.path_acronym,
                location: `${org?.city || ""}${
                  org?.city && org?.country_name ? ", " : ""
                }${org?.country_name || ""}`,
                main_contact_name: org?.contact_name,
                email: org?.contact_email,
              })),
            }))
            .sort((a, b) => a.customer_name?.localeCompare(b.customer_name))) ||
        []
      );
    },
  },
  methods: {
    ...mapActions(["fetchOrganisationRelUnRel", "fetchUser", "activateOrgRelationship", "deactivateOrgRelationship", "fetchPartners"]),
     onSearch(value){
      this.collapseIndex = null;
    },
    changeStatus(item, toActivate) {
      if(toActivate){
        this.confirmationModal.modalTitle = "Activate Customer";
        this.confirmationModal.modalContent = `Do you want to activate - ${item.customer_name}?`;
        this.confirmationModal.modalColor = "primary";
      }
      else{
        this.confirmationModal.modalTitle = "Deactivate Customer";
        this.confirmationModal.modalContent = `Do you want to deactivate - ${item.customer_name}?`;
        this.confirmationModal.modalColor = "danger";
      }
      this.confirmationModal.isShowPopup = true;
      this.confirmationModal.data= item.rawData;
      this.confirmationModal.toActivate = toActivate;
    },
    confirmationModalCallBack(action) {
      if (action === "Yes") {
        if(this.confirmationModal.toActivate) {
          this.activateOrgRelationship(this.confirmationModal.data.customer_organisation_id);
        } else {
          this.deactivateOrgRelationship(this.confirmationModal.data.rel_customer_organisation_id);
        }
      }
      this.confirmationModal.isShowPopup = false;
    },
    toggleDetails(item, index) {
      item.toggle = true;
      if (this.collapseIndex === index) {
        this.collapseIndex = null;
        this.tooltipHide();
        return;
      }
      this.collapseIndex = index;
    },
    toggleDetails1(item, index) {
      item.toggle = true;
      if (this.collapseIndex1 === index) {
        this.collapseIndex1 = null;
        this.tooltipHide();
        return;
      }
      this.collapseIndex1 = index;
    },
    onPartnerSearch(value) {
      clearTimeout(this.partnerSearchTimeout);
      this.partnerSearchValue = value;
      this.partnerSearchTimeout = setTimeout(() => {
        this.partnerPage = 1;
        this.fetchPartners({
          ...(this.partnerSearchValue ? { search_term: this.partnerSearchValue } : {}),
        }).then((res) => {
          this.partnerTotal = res?.data?.total || 0;
          this.partnerQueryCount = res?.data?.query_count || 0;
        });
      }, 500);
    },
    partnerPagechanged(pageNumber) {
      if (pageNumber === this.partnerPage || pageNumber < 1) return;
      this.partnerPage = pageNumber;
      const skip = (pageNumber - 1) * this.partnerPerPage;
      this.fetchPartners({
        skip,
        limit: this.partnerPerPage,
        ...(this.partnerSearchValue ? { search_term: this.partnerSearchValue } : {}),
      });
    },
    tooltipHide() {
      setTimeout(() => {
        let x = document.querySelectorAll(".tooltip");
        for (var i = 0; i < x.length; i++) {
          x[i].style.visibility = "hidden";
        }
      }, 50);
    },
  },
  mounted() {
    this.fetchUser().then((res) => {
      this.fetchOrganisationRelUnRel();
    });
    this.fetchPartners().then((res) => {
      this.partnerTotal = res?.data?.total || 0;
      this.partnerQueryCount = res?.data?.query_count || 0;
    });
  },
};
</script>
